import { IssueResolverType, MessageV2DTO } from 'support/types';

export type ReviewActionPlacement = 'banner' | 'header';

export type ReviewActionVisibility = {
  markAsReviewed: boolean;
  editFromReview: boolean;
};

type UseReviewActionButtonsArgs = {
  message: MessageV2DTO;
  placement: ReviewActionPlacement;
  issueResolver: IssueResolverType | undefined;
  hasErrors: boolean;
};

const EMPTY: ReviewActionVisibility = { markAsReviewed: false, editFromReview: false };

export const useReviewActionButtons = ({
  message,
  placement,
  issueResolver,
  hasErrors,
}: UseReviewActionButtonsArgs): ReviewActionVisibility => {
  const messageIsReviewed = !message.review || !!message.review.completed_at;
  if (messageIsReviewed) {
    return EMPTY;
  }

  if (issueResolver !== IssueResolverType.CURRENT_PARTNER) {
    return EMPTY;
  }

  const type = message.review?.type;

  if (placement === 'header') {
    if (type !== 'document_requires_manual_review') {
      return EMPTY;
    }

    return {
      markAsReviewed: !hasErrors,
      editFromReview: true,
    };
  }

  return EMPTY;
};
